import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import { AccessControlListProps, RoutePath } from '@quizzach/interfaces';

/**
 * Checks if a user is authenticated by verifying the presence and validity of a JWT token
 * stored in localStorage.
 */
const isAuthenticated = () => {
	const token = localStorage.getItem('userToken');

	if (token) {
		const decodedToken = jwtDecode(token);
		const tokenValid =
			decodedToken && decodedToken.exp && decodedToken.exp * 1000 > Date.now();
		return tokenValid;
	}
	return false;
};

/**
 * Component for managing access control based on the user's authentication status
 * and the required authorization level for specific routes.
 * If the user is not authenticated for protected routes, they are redirected to
 * the authentication page, with a state indicating the origin of the redirect.
 */
export const AccessControlList: React.FC<AccessControlListProps> = ({
	element,
	path,
	authorizationLevel,
}) => {
	if (authorizationLevel === 'authenticated' && !isAuthenticated()) {
		if (path === RoutePath.QuickSummary)
			return (
				<Navigate
					to={`${RoutePath.Login}`}
					state={{ source: 'quick' }}
					replace
				/>
			);
		if (path === RoutePath.GeneratorSummary)
			return (
				<Navigate
					to={`${RoutePath.Login}`}
					state={{ source: 'generator' }}
					replace
				/>
			);

		console.log(path);

		if (
			path === RoutePath.QuizStart ||
			path === RoutePath.QuizQuestionSlides ||
			path === RoutePath.QuizAnswerSlides ||
			path === RoutePath.QuizPlay ||
			path === RoutePath.QuizModeSelection ||
			path === RoutePath.QuizEnd ||
			path === RoutePath.QuizMidBreak1 ||
			path === RoutePath.QuizMidBreak2 ||
			path === RoutePath.QuizHalftime ||
			path === RoutePath.QuizMidBreakSingle ||
			path === RoutePath.QuizEstimationIntro ||
			path === RoutePath.QuizQuestionChapter ||
			path === RoutePath.QuizQuestionChapterEnd ||
			path === RoutePath.QuizAnswerChapter ||
			path === RoutePath.QuizAnswerChapterEnd
		) {
			return (
				<Navigate
					to={`${RoutePath.Login}`}
					state={{ source: 'quiz' }}
					replace
				/>
			);
		}
		if (path === RoutePath.Profile)
			return (
				<Navigate
					to={`${RoutePath.Login}`}
					state={{ source: 'profile' }}
					replace
				/>
			);
		if (path === RoutePath.Voucher)
			return (
				<Navigate
					to={`${RoutePath.Login}`}
					state={{ redirect: RoutePath.Voucher }}
					replace
				/>
			);
	}

	if (isAuthenticated()) {
		if (path === RoutePath.Register)
			return <Navigate to={`${RoutePath.Profile}`} replace />;
		if (path === RoutePath.Login)
			return <Navigate to={`${RoutePath.Profile}`} replace />;
	}
	return <>{element}</>;
};
